import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    // Kontaktseite: direkt zum Formular springen
    if (pathname === "/kontakt" && !hash) {
      const el = document.getElementById("kontakt-form");
      if (el) {
        const top = el.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo({ top, left: 0, behavior: "auto" });
        return;
      }
    }
    // Sofort nach oben – kein smooth-Scroll (überschreibt html { scroll-behavior: smooth })
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
